import React from 'react';
import { Typography, Space } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import {
  ArticleProductHighlight as ArticleProductHighlightProps,
  SanityKeyed
} from 'types/studio/studio';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage';
import UnifiedButton from 'shared/studio/UnifiedButton/UnifiedButton';
import { UnifiedButtonType } from 'shared/studio/UnifiedButton/UnifiedButton.types';

import styles from './EduArticleProductHighlight.module.scss';

export const EduArticleProductHighlight = ({
  _type: sectionType,
  image,
  text,
  unifiedButton
}: SanityKeyed<ArticleProductHighlightProps>) => (
  <Space top={{ xxs: 16 }} bottom={{ xxs: 16 }}>
    <div className={styles.wrapper}>
      <StudioHotspotImageV2 className={styles.image} image={image} />
      <Typography
        component="div"
        className={styles.text}
        variant="body"
        size="2"
        weight="700"
        color="black-new"
        noPadding>
        <CustomPortableText value={text} />
      </Typography>
      <UnifiedButton
        unifiedButton={unifiedButton as UnifiedButtonType}
        sectionType={sectionType}
        className={styles.button}
        size="small"
        theme="new"
      />
    </div>
  </Space>
);
